import Breadcrumbs from "../../layout-components/Breadcrumbs";
import DataTable, { Column } from "../../layout-components/DataTable";

const customers = [
  { id: 1, name: "Afsana", email: "afsana@example.com", phone: "0123456789", joinDate: "2024-08-15", status: "Active" },
  { id: 2, name: "John Doe", email: "john@example.com", phone: "0198765432", joinDate: "2024-09-10", status: "Inactive" },
  { id: 3, name: "Jane Smith", email: "jane@example.com", phone: "0181111222", joinDate: "2024-10-01", status: "Active" },
];

const columns: Column<typeof customers[0]>[] = [
  { key: "id", label: "SL" },
  { key: "name", label: "Name" },
  { key: "email", label: "Email" },
  { key: "phone", label: "Phone" },
  { key: "joinDate", label: "Join Date" },
  { key: "status", label: "Status" },
];

export default function Customer() {
  return (
    <div className="container-fluid p-0">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h1 className="h3 mb-0">Customer</h1>
        <Breadcrumbs />
      </div>

      <DataTable
        data={customers}
        columns={columns}
        onView={(item) => alert(`Viewing ${item.name}`)}
        onEdit={(item) => alert(`Editing ${item.name}`)}
        onDelete={(item) => alert(`Deleting ${item.name}`)}
      />
    </div>
  );
}
